import { NavLink } from "react-router-dom";
import { cn } from "../../utils/classNames";

const navItems = [
  { to: "/", label: "Home", icon: "⌂" },
  { to: "/quiz", label: "Quiz", icon: "✧" },
  { to: "/recommendations", label: "Recs", icon: "▷" },
  { to: "/mood-board", label: "Mood", icon: "☾" },
  { to: "/saved-shows", label: "Saved", icon: "♡" },
];

export default function MobileNav() {
  return (
    <nav className="fixed inset-x-3 bottom-3 z-40 rounded-2xl border border-hookd-line bg-hookd-ink/95 px-2 py-2 shadow-panel backdrop-blur md:hidden">
      <div className="grid grid-cols-5 gap-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                "flex min-h-12 flex-col items-center justify-center gap-1 rounded-hookd text-[11px] font-semibold text-hookd-muted",
                isActive && "bg-hookd-empress/15 text-hookd-empress"
              )
            }
          >
            <span className="text-lg leading-none">{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
